@let filesCollection = filesEc;
@let management = filesCollection.management;
@let managementSelectors = management.selectors;
@let canUpload = managementSelectors.canUpload.asSignal();
@let fileInputVersion = managementSelectors.fileInputVersion.asSignal();
@let fileTypes = supportedFileExtensions;
@let fileTypesLabel = fileTypes.join(', ');
@let maximumFileSize = maximumFileSizeLabel;
@let fileOperations = filesCollection.fileOperations;
@let uploading = fileOperations.selectors.isUploading.asSignal();

<atn-ds-widget title="Upload document">
  <div class="atn-admin-knowledge-bases-document-upload">
    <div class="atn-admin-knowledge-bases-document-upload__policy">
      Supported files: {{ fileTypesLabel }}.<br />
      Maximum size: {{ maximumFileSize }}.
    </div>

    <div class="atn-admin-knowledge-bases-document-upload__control">
      @for (version of [fileInputVersion]; track version) {
        <atn-ds-file
          [types]="fileTypes"
          [isUploading]="uploading"
          (fileChange)="
            management.actions.selectFile
              .from('Admin.KnowledgeBases.File.Selected')
              .dispatch($event)
          "
        />
      }
    </div>

    <div class="atn-admin-knowledge-bases-document-upload__action">
      <atn-ds-button
        [disabled]="!canUpload || uploading"
        [loading]="uploading"
        (click)="
          management.actions.upload
            .from('Admin.KnowledgeBases.Upload.SelectedFile')
            .dispatch()
        "
      >
        Upload
      </atn-ds-button>
    </div>
  </div>
</atn-ds-widget>
